<div id="hide-menu" class="btn-header pull-left">
        <span> <a (click)="onToggle()" title="Collapse Menu"><i
                class="fa fa-reorder"></i></a> </span>
</div>